import React from 'react'
import RobiyaHeader from './RobiyaHeader'
import { RobiyaSingleProject } from './RobniyaSinglePage'

const Robiya = ({open}) => {
  return (
    <div>
        <RobiyaHeader/>
        <RobiyaSingleProject open={open}/>
    </div>
  )
}

export default Robiya